var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#081131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 26.2113C21.7407 26.2113 22.6585 25.9977 23.4429 25.5704C24.244 25.1268 24.8698 24.4777 25.3204 23.6232H28.75C28.0991 25.2664 27.0561 26.5317 25.6208 27.419C24.1856 28.3063 22.5417 28.75 20.6893 28.75C18.7366 28.75 17.001 28.2324 15.4823 27.1972C13.9636 26.1455 12.9039 24.7488 12.3031 23.007H10V21.0845H11.8525C11.8191 20.6244 11.8024 20.2629 11.8024 20C11.8024 19.7371 11.8191 19.3756 11.8525 18.9155H10V16.993H12.3031C12.9039 15.2512 13.9636 13.8627 15.4823 12.8275C17.001 11.7758 18.7366 11.25 20.6893 11.25C22.525 11.25 24.1605 11.7019 25.5958 12.6056C27.0477 13.493 28.0991 14.7582 28.75 16.4014H25.3204C24.8698 15.5469 24.244 14.9061 23.4429 14.4789C22.6585 14.0352 21.7407 13.8134 20.6893 13.8134C19.471 13.8134 18.3945 14.0927 17.4599 14.6514C16.5421 15.2101 15.8411 15.9906 15.3571 16.993H20.6893V18.9155H14.8064C14.7563 19.2606 14.7313 19.6221 14.7313 20C14.7313 20.3779 14.7563 20.7394 14.8064 21.0845H20.6893V23.007H15.3571C15.8411 24.0258 16.5421 24.8146 17.4599 25.3732C18.3945 25.9319 19.471 26.2113 20.6893 26.2113Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/eur.99a6bf86e7202181d8a306a07aa81efe.svg";
export { ForwardRef as ReactComponent };